import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getTrackingIntervalDisplay,
  TrackingInterval,
} from '@/features/projects/create-subproject/types/tracking-interval';
import { EditTrackingIntervalDialog } from '@/features/projects/project-details/components/edit-tracking-interval-dialog';
import {
  ProjectPropertiesMenuItem,
  ProjectPropertiesMenuItemPrefix,
  ProjectPropertiesMenuItemValue,
} from '@/features/projects/project-details/components/layouts/project-properties-menu-layout';
import { useUpdateTrackingInterval } from '@/features/projects/project-details/hooks/use-update-tracking-interval';
import { ProjectWithParent } from '@/shared/types/api';

export const TrackingIntervalItem = ({
  project,
  trackingInterval,
}: {
  project: ProjectWithParent;
  trackingInterval?: TrackingInterval | undefined;
}) => {
  const { t } = useTranslation('subproject', { keyPrefix: 'TrackingInterval' });

  const mutation = useUpdateTrackingInterval();

  const handleIntervalChange = (newInterval: TrackingInterval) => {
    mutation.mutate({
      projectId: project.id,
      interval: newInterval,
    });
  };

  const isClient = project.type === 'subproject_client';
  const [isOpen, setIsOpen] = useState(false);

  // Only client view can edit tracking interval
  const isEditable = isClient;

  return (
    <EditTrackingIntervalDialog
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      currentInterval={trackingInterval}
      onIntervalChange={handleIntervalChange}
    >
      <div>
        <ProjectPropertiesMenuItem
          isEditable={isEditable}
          onEdit={() => setIsOpen(true)}
        >
          <ProjectPropertiesMenuItemPrefix>
            {t('title')}
          </ProjectPropertiesMenuItemPrefix>
          <ProjectPropertiesMenuItemValue>
            <span>
              {trackingInterval
                ? getTrackingIntervalDisplay({
                    interval: trackingInterval,
                    t,
                  })
                : t('select')}
            </span>
          </ProjectPropertiesMenuItemValue>
        </ProjectPropertiesMenuItem>
      </div>
    </EditTrackingIntervalDialog>
  );
};
